import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { getToken } from 'utils/token'
import { common as commonApi } from 'redux/modules/api'
import { notification } from 'redux/modules/app'
import { setFile } from 'redux/modules/files'
import { IMAGE_SIZES } from 'constants/enums'
import getFileType from 'utils/getFileType'
import queryString from 'query-string'

function decorator(config = {}) {
  return ComposedComponent => {
    @withRouter
    @connect(
      ({ auth, files }) => ({
        user: auth.user,
        activeOrganization: auth.organization,
        files
      }),
      { loadingImage: commonApi.loadingImage, setFile, push, notification }
    )
    class DownloadFile extends PureComponent {
      static propTypes = {
        decoWithCode: PropTypes.bool,
        user: PropTypes.object.isRequired,
        location: PropTypes.object,
        activeOrganization: PropTypes.object,
        loadingImage: PropTypes.func.isRequired,
        // notification: PropTypes.func.isRequired,
        setFile: PropTypes.func.isRequired,
        files: PropTypes.object.isRequired
      }

      static defaultProps = {
        activeOrganization: {}
      }

      constructor(props) {
        super(props)
        this.state = {
          downloadedFile: null
        }
      }

      handleDownloadFile = (fileUrl, size = IMAGE_SIZES.default.size) => {
        const { files, activeOrganization } = this.props

        if (fileUrl === null) {
          return
        }

        // if (fileUrl && fileUrl.includes('/public')) {
        //   this.handleDownloadPublic(fileUrl)
        //   return
        // }

        if (!__CLIENT__ || files[fileUrl] || !fileUrl) {
          return
        }

        let fileUrlWithQuery = fileUrl
        let urlPrefix = '?'

        if (fileUrl.includes('?')) {
          urlPrefix = '&'
        }

        fileUrlWithQuery = `${fileUrl}${urlPrefix}${size}`

        if (activeOrganization.id) {
          fileUrlWithQuery = `${fileUrlWithQuery}
          ${urlPrefix}organizationId=${get(activeOrganization, 'id')}&userType=${get(activeOrganization, 'userType')}`
        }

        const xhr = new XMLHttpRequest()
        const self = this

        this.props.loadingImage(true)

        xhr.open('GET', fileUrlWithQuery, true)
        xhr.setRequestHeader(
          'Authorization',
          'Bearer ' + getToken(this.props.user)
        )
        xhr.responseType = 'blob'

        self.props.setFile({
          fileUrl,
          loading: true
        })

        /* eslint-disable */
        xhr.onload = function() {
          if (this.status === 200) {
            self.props.setFile({
              fileUrl,
              fileLocalUrl: URL.createObjectURL(this.response),
              loading: false,
              type: getFileType(fileUrl),
              name: self.handleGetFileName(fileUrl),
              size
            })
            self.setState({
              downloadedFile: URL.createObjectURL(this.response)
            })
          }
          self.props.loadingImage(false)
        }
        /* eslint-enable */

        xhr.send()
      }

      handleDownloadFileCode = file => {
        const { activeOrganization } = this.props
        const operator = file.includes('?') ? '&' : '?'
        const query = queryString.parse(get(this.props, 'location.search'))
        let fileUrl = `${file}${operator}authorizationCode=${get(query, 'authorizationCode')}`

        if (activeOrganization.id) {
          fileUrl += `&organizationId=${get(activeOrganization, 'id')}&userType=${get(activeOrganization, 'userType')}`
        }

        this.setState({
          downloadedFile: fileUrl
        })
        this.props.setFile({
          fileUrl: file,
          fileLocalUrl: fileUrl,
          loading: false,
          type: getFileType(file),
          name: this.handleGetFileName(file)
        })
      }

      handleGetFileName = fileUrl => {
        if (!fileUrl) {
          return
        }

        fileUrl = fileUrl.replace(/\+/g, '%20')
        const fileName = decodeURIComponent(fileUrl).replace(
          /^.*(\\|\/|\:)/, // eslint-disable-line
          ''
        )

        return fileName.split('.')[0]
      }

      handleDownloadPublic = fileUrl => {
        const link = document.createElement('a')

        document.body.appendChild(link)
        link.href = fileUrl

        link.click()
      }

      render() {
        const isWithCode = config.withCode || this.props.decoWithCode

        return (
          <ComposedComponent
            {...this.props}
            onDownloadFile={
              isWithCode ? this.handleDownloadFileCode : this.handleDownloadFile
            }
            downloadedFile={this.state.downloadedFile}
          />
        )
      }
    }
    return DownloadFile
  }
}

export default decorator
